import type { DicaContent, AtencaoContent } from '@content/topicos-content.js'

interface Props {
  dicas: DicaContent[]
  atencao: AtencaoContent[]
  nested?: boolean
}

export function PassoAlertasSection({ dicas, atencao, nested }: Props) {
  if (dicas.length === 0 && atencao.length === 0) return null

  return (
    <section
      className={nested ? 'cf3-block cf3-block--nested' : 'cf3-block'}
      aria-labelledby='alertas-heading'
    >
      <h2 id='alertas-heading' className='cf3-subsection-title'>
        Alertas e dicas
      </h2>
      <div className='cf3-insights'>
        {dicas.map((d, i) => (
          <article key={`d-${i}`} className='cf3-insight cf3-insight--gold'>
            <p className='cf3-insight__text'>{d.texto}</p>
          </article>
        ))}
        {atencao.map((a, i) => (
          <article key={`a-${i}`} className='cf3-insight cf3-insight--warn'>
            <p className='cf3-insight__text'>{a.texto}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
